module.exports = __webpack_public_path__ + "img/cisco_logo.f2423565.jpg";